module.exports = __webpack_public_path__ + "media/app/assets/mailers/vpn_key-48-primary-528dc6cad789356f05d5bb160c7cffba.png";